import { Product } from '../models/Product';

import imgBrigadeiro from '../assets/cards/Bala de Brigadeiro.png';
import imgChocolate from '../assets/cards/Bala de chocolate.png';
import imgCoco from '../assets/cards/Bala de coco tradicional.png';
import imgLeiteNinho from '../assets/cards/Bala de leite ninho.png';
import imgLimao from '../assets/cards/Bala de limao.png';
import imgMaracuja from '../assets/cards/Bala de Maracuja.png';
import imgMorango from '../assets/cards/Bala de Morango.png';

const products: Product[] = [
  {
    id: 1,
    name: 'Bala de brigadeiro',
    description: 'Brigadeiro macio com cacau intenso e brilho de festa.',
    image: imgBrigadeiro,
    price: 45.0,
  },
  {
    id: 2,
    name: 'Bala de prestígio (chocolate + coco)',
    description: 'Casquinha de chocolate envolvendo coco úmido, lembra o clássico Prestígio.',
    image: imgChocolate,
    price: 45.0,
  },
  {
    id: 3,
    name: 'Bala de coco tradicional',
    description: 'Leve e amanteigada, feita com coco fresco que derrete na boca.',
    image: imgCoco,
    price: 40.0,
  },
  {
    id: 4,
    name: 'Bala de leite ninho',
    description: 'Doce cremoso de leite ninho com final suave de leite em pó.',
    image: imgLeiteNinho,
    price: 45.0,
  },
  {
    id: 5,
    name: 'Bala de limão',
    description: 'Recheio cítrico e refrescante, equilibra acidez e doçura.',
    image: imgLimao,
    price: 45.0,
  },
  {
    id: 6,
    name: 'Bala de maracujá',
    description: 'Aroma tropical com recheio azedinho que desperta o paladar.',
    image: imgMaracuja,
    price: 45.0,
  },
  {
    id: 7,
    name: 'Bala de morango',
    description: 'Morango cremoso com notas de fruta fresca e final doce.',
    image: imgMorango,
    price: 45.0,
  },
];

export const getProducts = (): Product[] => {
  return products;
};

export const getProductById = (id: number): Product | undefined => {
  return products.find((product) => product.id === id);
};

